import { render, staticRenderFns } from "./AppBottomScreen.vue?vue&type=template&id=27cfb8bb&scoped=true"
import script from "./AppBottomScreen.vue?vue&type=script&lang=js"
export * from "./AppBottomScreen.vue?vue&type=script&lang=js"
import style0 from "./AppBottomScreen.vue?vue&type=style&index=0&id=27cfb8bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cfb8bb",
  null
  
)

export default component.exports